import * as React from 'react';
import {withAuthorization} from "../../firebase/withAuthorization";
import remergeCondition from "../../firebase/conditions";
import FileSystemContainer from "../../containers/FileSystemContainer";
import BasicLayout from "../../layout/BasicLayout";

class Files extends React.PureComponent {

    render() {
        return (
            <BasicLayout>
                <FileSystemContainer/>
            </BasicLayout>
        );
    }
}

const authCondition = (authUser: any) => remergeCondition(authUser);

export default withAuthorization(authCondition)(Files);
